import { groupBy } from "lodash";
export default {
  computed: {
    byAnswerFeel() {
      const byFeel = _.groupBy(this.questions, "answered");
      const questionsLength = this.questions.length || 0;
      const positiveLength = byFeel["1"] ? byFeel["1"].length : 0;
      const negativeLength = byFeel["0"] ? byFeel["0"].length : 0;
      const unansweredLength = byFeel["null"] ? byFeel["null"].length : 0;

      return {
        all: {
          count: questionsLength
        },
        positive: {
          count: positiveLength,
          percentage: this.getPercentage(positiveLength, questionsLength)
        },
        negative: {
          count: negativeLength,
          percentage: this.getPercentage(negativeLength, questionsLength)
        },
        unanswered: {
          count: unansweredLength,
          percentage: this.getPercentage(unansweredLength, questionsLength)
        }
      };
    }
  },
  methods: {
    getPercentage(partialValue, totalValue) {
      return Math.floor((partialValue / totalValue) * 100);
    }
  }
}